import React from "react";


function Projets() {
    return <div className="projets">
        <h2 className="h2">Projets personnels</h2>
        <ul>
            <li>Réalisation de ce CV en ligne avec le framework ReactJS</li>
            <li>Développement d'un site internet pour le ski club <strong><a href="https://cigognes-tarbes-ski.fr">"Les Cigognes de Tarbes"</a></strong></li>
            <li>Développement d'un portfolio (en cours ...)</li>

        </ul>

    </div>
}

export default Projets